import type { LoginError, LoginErrorType } from '../domain/types'
import type { LoginErrorAPIResponse } from './types'
import { LOGIN_API_ERROR_CODES } from './types'

const LOGIN_ERROR_TYPE_BY_API_CODE: Record<string, LoginErrorType | undefined> = {
  [LOGIN_API_ERROR_CODES.VALIDATION_FAILED]: 'validationFailed',
  [LOGIN_API_ERROR_CODES.INVALID_CREDENTIALS]: 'invalidCredentials',
  [LOGIN_API_ERROR_CODES.ACCOUNT_NOT_VERIFIED]: 'accountNotVerified',
  [LOGIN_API_ERROR_CODES.WEAK_PASSWORD]: 'weakPassword',
  [LOGIN_API_ERROR_CODES.RATE_LIMITED]: 'rateLimited',
  [LOGIN_API_ERROR_CODES.UNEXPECTED_ERROR]: 'unexpectedError',
}

function toErrorType(errorCode: string | undefined): LoginErrorType {
  return LOGIN_ERROR_TYPE_BY_API_CODE[errorCode ?? ''] ?? 'unexpectedError'
}

export function mapLoginError(response: LoginErrorAPIResponse | undefined): LoginError {
  const type = toErrorType(response?.errorCode)

  if (type !== 'rateLimited')
    return { type }

  const retryAfterSeconds = response?.retryAfterSeconds

  if (retryAfterSeconds === undefined || retryAfterSeconds <= 0)
    return { type: 'unexpectedError' }

  return { type, retryAfterSeconds }
}
